<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:120px; padding-left:15px; padding-right: 15px;">

  <div fxLayout="row" fxFlex="grow" style="margin-bottom: 10px;" fxLayoutAlign="start">

    <div fxLayoutAlign="start" fxFlexAlign="start" fxFlex="100" class="pageTitle">{{pageTitle}}</div>

  </div>

  <div fxLayout="row" *ngIf="isPageLoading"><app-loading></app-loading></div>
  <div *ngIf="!isPageLoading" fxLayout="row" fxFlex="grow" style="width: 1200px !important;">
    <mat-horizontal-stepper #stepper linear="true" (selectionChange)="next()">

      <mat-step label="Τίτλος">
        <div fxLayout="column">

          <div *ngIf="isConsent" fxLayout="column" fxLayoutAlign="flex-start" fxFlex="grow">
            <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή κατηγορίας δήλωσης</h4> </div>
            <div fxLayout="row" style="margin-top: 1%">
              <mat-form-field appearance="outline" style="font-family: 'Century Gothic', sans-serif !important;">
                <mat-label>Επιλέξτε Κατηγορία</mat-label>
                <mat-select [(ngModel)]="selectedFormType" (selectionChange)="categoryChanged()"
                            [disabled]="typesLoading"
                            style=" font-family: 'Century Gothic', sans-serif !important;">
                  <mat-option style=" font-family: 'Century Gothic', sans-serif !important; padding:15px;"
                              *ngFor="let option of formTypes"
                              [value]="option">{{option.description}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="column" fxLayoutAlign="flex-start" fxFlex="grow">
            <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Συμπλήρωση τίτλου</h4> </div>
            <div fxLayout="row" style="margin-top: 1%">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
              <mat-label>{{displayTitle}}</mat-label>
              <label>
                <input style="font-family: 'Century Gothic', sans-serif !important;" matInput
                       [(ngModel)]="formTitle"
                       [maxLength]="80">
              </label>
              <mat-hint align="end">{{formTitle.length}} / 80</mat-hint>
            </mat-form-field>
            </div>
          </div>

          <div fxLayout="column" fxLayoutAlign="flex-start" fxFlex="grow">
            <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Συμπλήρωση υποτίτλου</h4> </div>
            <div fxLayout="row" style="margin-top: 1%">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
              <mat-label>Υπότιτλος</mat-label>
              <label>
                <input style="font-family: 'Century Gothic', sans-serif !important;" matInput
                       [(ngModel)]="formDescription"
                       [maxLength]="100">
              </label>
              <mat-hint align="end">{{formDescription.length}} / 100</mat-hint>
            </mat-form-field>
            </div>
          </div>

        </div>
        <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
          <button mat-raised-button class="stepperButton" matStepperNext [disabled]="isFirstStepInvalid()"
                  (click)="next()">
            Επόμενο
          </button>
        </div>
      </mat-step>

      <mat-step label="Κείμενο">
        <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Συμπλήρωση ενημερωτικού κειμένου</h4> </div>

        <quill-editor [styles]="editorStyle" [(ngModel)]="htmlContent"
                      (onEditorCreated)="onEditorCreated($event)"
                      style="width:100%; height:600px; min-height: 600px; max-height: 600px;"></quill-editor>

        <div fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>

          <div>
            <button mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>

      <!-- is Consent Form-->
      <mat-step *ngIf="optionsStep && !isAffirmation" label="Ερωτήσεις">

        <div fxLayout="column">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή ερωτήσεων</h4> </div>

          <div fxLayout="row" fxFlex="grow">
            <div style="max-height:650px; overflow-y:auto;">

              <div fxLayout="row wrap" *ngIf="isConsentForm()" style="margin-top:5px;" fxLayoutGap="20px">
                <div fxFlex="48" *ngFor="let item of questions; let i = index" class="questionBox"
                     fxLayoutAlign="start center center">
                  <div fxFlexAlign="center"
                       style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
                    <div fxFlex="80">{{ item.title }}</div>
                    <div fxFlex="20" fxLayoutAlign="end center center">
                      <mat-slide-toggle [checked]="item.value" (change)="changeQuestionState(i)"></mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>


        <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>
          <div>
            <button mat-raised-button [disabled]="invalidQuestionsStep()" class="stepperButton" color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>

      <mat-step *ngIf="optionsStep && !isAffirmation" label="Ιδιότητες">

        <!--Has two step-->
        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" fxLayoutGap="20px"
             style="margin-top:20px;">

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; padding:5px; margin-right:5px">
            <div fxFlex="60" fxLayoutAlign="start center center"> Yποχρεωτική ύπαρξη επιβεβαίωσης
              αυθεντικοποίησης 2
              βημάτων?
            </div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="twoStepChange()" [checked]='isTwoStepActive'></mat-slide-toggle>
            </div>
          </div>

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word;  padding:5px;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Εμφάνιση περισσοτέρων πληροφοριών</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="hasFullInfoChanged($event)"
                                [checked]='hasFullInfo'></mat-slide-toggle>
            </div>
          </div>
        </div>


        <!--        Has deadline-->
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center center" fxLayoutGap="20px">

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Ύπαρξη προθεσμίας στην αίτηση</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="hasDeadLineChanged($event)"
                                [checked]='hasDeadline'></mat-slide-toggle>
            </div>
          </div>

          <div class="optionsBox" fxFlex="50" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important; margin-top:20px;">
              <mat-label>Ημερομηνία προθεσμίας</mat-label>
              <label>
                <input [disabled]="!hasDeadline" [min]="minDate" matInput [matDatepicker]="picker"
                       [(ngModel)]="specificDate"
                       placeholder="Ημερομηνία προθεσμίας" readonly>
              </label>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>


        <!--has max Slots-->
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center center" fxLayoutGap="20px">

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Κάλυψη θέσης</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="hasMaxSlotsChanged($event)"
                                [checked]='hasMaxSlots'></mat-slide-toggle>
            </div>
          </div>

          <div class="optionsBox" fxFlex="50" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px; margin-top:20px;">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important; margin-top:20px;">
              <mat-label>Πλήθος θέσεων</mat-label>
              <label>
                <input [disabled]="!hasMaxSlots" type="number" matInput [(ngModel)]="maxSlots"
                       placeholder="Πλήθος θέσεων">
              </label>

            </mat-form-field>
          </div>
        </div>


        <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>
          <div>
            <button mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>

      <mat-step *ngIf="optionsStep && !isAffirmation" label="Αυτοματισμοί">
        <div fxLayout="column">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή αυτοματοποιημένων ενεργειών</h4> </div>

          <div fxLayout="row" fxFlex="grow">
            <div style="max-height:650px; overflow-y:auto;">

              <div fxLayout="row wrap" style="margin-top:5px;" fxLayoutGap="20px">

                <div fxFlex="48" *ngFor="let item of automations; let i = index" class="questionBox1"
                     fxLayoutAlign="start center center">
                  <div fxFlexAlign="center"
                       style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
                    <div fxLayout="column" fxFlex="80">
                      <div fxLayout="row">
                        {{ item.description }}
                      </div>
                      <div fxLayout="row" *ngIf="item.selected">
                        <mat-form-field class="demo-chip-list" style="width: 100%;">
                          <mat-chip-list *ngIf="i === 0" #chipList>
                            <mat-chip
                                    style="background-color: var(--primary); color: white;"
                                    *ngFor="let email of emails"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="removeEmail(email)">
                              {{email}}
                              <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input
                                    placeholder="Νέο email"
                                    #emailInput
                                    [formControl]="emailsCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur"
                                    (matChipInputTokenEnd)="addEmail($event)"
                            />
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                              {{ email.email }}
                            </mat-option>
                          </mat-autocomplete>

                          <mat-chip-list *ngIf="i === 1" #chipList1>
                            <mat-chip
                                    style="background-color: var(--primary); color: white;"
                                    *ngFor="let email of emails1"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="removeEmail1(email)">
                              {{email}}
                              <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input
                                    placeholder="Νέο email"
                                    #emailInput1
                                    [formControl]="emailsCtrl1"
                                    [matAutocomplete]="auto1"
                                    [matChipInputFor]="chipList1"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur"
                                    (matChipInputTokenEnd)="addEmail1($event)"
                            />
                          </mat-chip-list>


                          <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selected1($event)">
                            <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                              {{ email.email }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="20" fxLayoutAlign="end center center">
                      <mat-slide-toggle [checked]="item.selected" (change)="automationSelection(item.id)"></mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>

          <div>
            <button mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>

      <mat-step *ngIf="!isAffirmation" label="Προεπισκόπηση και Δημιουργία">

        <mat-card class="preview-card">
          <!-- Card Header with Gradient -->
          <div class="preview-card-header">
            <div class="preview-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="preview-header-content">
              <h3 class="preview-title">{{this.formTitle}}</h3>
              <span class="preview-subtitle" *ngIf="formDescription">{{this.formDescription}}</span>
            </div>
          </div>

          <mat-card-content>
            <div fxLayout="column">

              <!--                Text-->
              <div fxLayout="column" class="preview-content" [innerHTML]="transform(htmlContent)"></div>


              <!--                Deadline And PeopleAttendance-->
              <div fxLayout="row" fxFlex="grow" style="margin-top:5px; padding: 20px;" fxLayoutGap="5px">

                <div style="height:100px;" fxFlex="50">

                  <div fxLayout="row" *ngIf="hasDeadline" style="margin-top:5px;">
                    <mat-form-field appearance="outline"
                                    style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
                      <mat-label>Ημερομηνία προθεσμίας</mat-label>
                      <input [min]="minDate" matInput [matDatepicker]="picker"
                             [(ngModel)]="specificDate"
                             placeholder="Ημερομηνία προθεσμίας" readonly>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                  </div>
                </div>

                <div fxFlex="50">
                  <div fxLayout="column" style="margin-top: 5px;">
                    <div fxLayout="row" *ngIf="hasMaxSlots">
                      <mat-form-field appearance="outline"
                                      style="width:100%; font-family: 'Century Gothic', sans-serif !important;">
                        <mat-label>Πλήθος θέσεων</mat-label>
                        <label>
                          <input type="number" matInput readonly [value]="maxSlots"
                                 placeholder="Υπολοιπόμενες θέσεις">
                        </label>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <!---->

              <!--                Info Details-->
              <div
                style="padding: 10px 20px 20px 10px; border: 1px solid #0000003b; border-radius: 4px; margin-top: 0;"
                ngStyle.lt-md="width:inherit;" fxFlex="grow"
                *ngIf="selectedQuestions && selectedQuestions.length > 0">
                <p><span class="paragraph"></span><strong>Συγκατάθεση:</strong>
                </p>
                <p><span class="paragraph"></span>Με τη συμπλήρωση των κατωτέρω πεδίων, συναινώ στην
                  επεξεργασία των
                  δεδομένων
                  υγείας
                  μου που έχω καταχωρίσει
                  ανωτέρω, για τους σκοπούς που αναφέρονται στην ενημέρωση που συνοδεύει την παρούσα
                  συγκατάθεση.</p>
                <div style="padding-left:30px;">
                  <div style="margin-top: 20px;padding-bottom: 10px;display: flex;
    flex-direction: column;
    align-items: center;">

                    <form class="example-form" fxLayout="column" *ngIf="!hasFullInfo">

                      <div fxLayout="row">
                        <mat-form-field class="example-full-width">
                          <label>
                            <input matInput placeholder="Ονοματεπώνυμο χρήστη" readonly
                                   value="">
                          </label>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row">
                        <mat-form-field class="example-full-width">
                          <label>
                            <input matInput placeholder="Ονοματεπώνυμο" readonly
                                   value="">
                          </label>
                        </mat-form-field>
                      </div>

                      <div fxLayout="row">
                        <mat-form-field class="example-full-width">
                          <label>
                            <input matInput placeholder="Έτος γέννησης" readonly
                                   value="">
                          </label>
                        </mat-form-field>
                      </div>

                    </form>

                    <form class="example-form" fxLayout="column" *ngIf="hasFullInfo">

                      <div fxLayout="row wrap" fxFlex="100" fxLayoutGap.lt-md="10px">

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Επώνυμο" readonly value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Όνομα" readonly value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Όνομα Πατέρα" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Όνομα Μητέρας" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Τόπος Γέννησης" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Έτος Γέννησης" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Τόπος Κατοικίας" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Οδός" readonly value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Ταχ. Κώδικας" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Αριθμός Ταυτότητας" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="25" fxFlex.lt-md="25" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Ημ. Εκδ. Ταυτότητας" readonly
                                     value="">
                            </label>
                          </mat-form-field>
                        </div>

                        <div fxFlex.md="50" fxFlex.sm="100" fxFlex.gt-md="25">
                          <mat-form-field>
                            <label>
                              <input matInput placeholder="Τηλέφωνο" readonly value="">
                            </label>
                          </mat-form-field>
                        </div>
                      </div>

                    </form>

                  </div>
                </div>

                <div style="margin-top: 20px;border-bottom: 1px solid #0000003b;padding-bottom: 10px;"
                     *ngFor="let item of selectedQuestions">
                  <div style="display: inline-block;width: 80%;">
                    <span><strong>{{item.title}}</strong></span>
                  </div>
                  <div style="float:right;width: 20%;display: flex;justify-content: center;">
                    <mat-slide-toggle class="example-margin" [checked]="item.value" disabled="true"
                                      color="primary">
                    </mat-slide-toggle>
                  </div>
                </div>
                <!---->
              </div>

            </div>
          </mat-card-content>
        </mat-card>


        <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>
          <div>
            <button *ngIf="!editMode" class="stepperButton" mat-raised-button [class.spinner]="requestLoading" [disabled]="requestLoading"
                    (click)="submitForm()"
                    style="width:250px;">Δημιουργία
            </button>
            <button *ngIf="editMode" class="stepperButton" mat-raised-button [class.spinner]="requestLoading" [disabled]="requestLoading"
                    (click)="submitForm()"
                    style="width:250px;">Ενημέρωση
            </button>
          </div>
        </div>

      </mat-step>
      <!--      -->


      <!--      is Affirmation-->
      <mat-step *ngIf="isAffirmation" label="Δραστηριότητα" state="chat">
        <div fxLayout='column' class="stepperContent">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή δραστηριότητας</h4> </div>

          <!--Activity Selection-->
          <div fxLayout="row" fxLayoutAlign="center center center">

            <div fxFlex="50" fxFlexAlign="center"
                 style="width: 100%; word-break: break-word; overflow-wrap: break-word; padding:5px; margin-right:5px;">
              <div fxFlex="100" fxLayoutAlign="start center center"
                   style="font-family: 'Century Gothic', sans-serif;">Επιλογή δραστηριότητας
              </div>
            </div>


            <div fxFlex="50" fxFlexAlign="center" fxLayoutAlign="center center center"
                 style="width: 100%; padding:5px; margin-right:5px">
              <div fxFlex="grow" fxLayoutAlign="start center center"
                   style="align-content: center; align-items: center;">
                <mat-form-field appearance="outline" style="width: 100%;" fxFlexAlign="center">
                  <mat-select fxFlexAlign="center" [(ngModel)]="selectedActivity">
                    <mat-option *ngFor="let activity of activities"
                                [value]="activity">{{activity.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

          </div>
          <!---->

          <!--Buttons-->
          <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
            <div fxFlex="grow">
              <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
            </div>
            <div>
              <button [disabled]="!selectedActivity" class="stepperButton" mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
            </div>
          </div>
          <!---->
        </div>
      </mat-step>

      <mat-step *ngIf="optionsStep && isAffirmation" label="Ιδιότητες">

        <!--Has two step-->
        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" fxLayoutGap="20px"
             style="margin-top:20px;">

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center" fxLayout="column"
               style="word-break: break-word; overflow-wrap: break-word; padding:5px; margin-right:5px">
            <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή ύπαρξης κωδικού 2 βημάτων στην δήλωση</h4> </div>
            <div fxLayout="row" style="margin-top: 2%;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Yποχρεωτική ύπαρξη κωδικού 2 βημάτων?
            </div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="twoStepChange()" [checked]='isTwoStepActive'></mat-slide-toggle>
            </div>
            </div>
          </div>

          <div fxFlex="50" class="optionsBox" fxFlexAlign="center"  fxLayout="column"
               style="word-break: break-word; overflow-wrap: break-word;  padding:5px;">
            <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή ύπαρξης πεδίου σχολίων στην δήλωση</h4> </div>

            <div fxLayout="row" style="margin-top: 2%;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Υπάρχει περιοχή σχολίων στην δήλωση?</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="commentAreaChange()" [checked]='commentArea'></mat-slide-toggle>
            </div>
            </div>
          </div>
        </div>

        <!--        Has deadline-->
        <div fxLayout="column" fxFlex="100" style="width: 100%; margin-top: 1%;">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή προθεσμίας στην δήλωση</h4> </div>

          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center center"  fxLayoutGap="20px">
          <div fxFlex="50" class="optionsBox" fxFlexAlign="start"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Ύπαρξη προθεσμίας στην δήλωση</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="hasDeadLineChanged($event)"
                                [checked]='hasDeadline'></mat-slide-toggle>
            </div>
          </div>

          <div class="optionsBox" fxFlex="50" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important; margin-top:20px;">
              <mat-label>Ημερομηνία προθεσμίας</mat-label>
              <label>
                <input [disabled]="!hasDeadline" [min]="minDate" matInput [matDatepicker]="picker1"
                       [(ngModel)]="specificDate"
                       placeholder="Ημερομηνία προθεσμίας" readonly>
              </label>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          </div>
        </div>

        <!--has max Slots-->
        <div fxLayout="column" fxFlex="100" style="width: 100%; margin-top: 1%;">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;"> Επιλογή Θέσεων στην δήλωση</h4> </div>


          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center center"  fxLayoutGap="20px">
            <div fxFlex="50" class="optionsBox" fxFlexAlign="start"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
            <div fxFlex="60" fxLayoutAlign="start center center"> Κάλυψη θέσης</div>
            <div fxFlex="40" fxLayoutAlign="end center center">
              <mat-slide-toggle (change)="hasMaxSlotsChanged($event)"
                                [checked]='hasMaxSlots'></mat-slide-toggle>
            </div>
          </div>

          <div class="optionsBox" fxFlex="50" fxFlexAlign="center"
               style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px; margin-top:20px;">
            <mat-form-field appearance="outline"
                            style="width:100%; font-family: 'Century Gothic', sans-serif !important; margin-top:20px;">
              <mat-label>Πλήθος θέσεων</mat-label>
              <label>
                <input [disabled]="!hasMaxSlots" type="number" matInput [(ngModel)]="maxSlots"
                       placeholder="Πλήθος θέσεων">
              </label>

            </mat-form-field>
          </div>
          </div>
        </div>


        <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>
          <div>
            <button mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>


      <mat-step *ngIf="isAffirmation" label="Αυτοματισμοί">
        <div fxLayout="column">
          <div fxLayout="row"><h4 style=" font-family: 'Century Gothic', sans-serif !important;">Επιλογή αυτοματοποιημένων ενεργειών</h4> </div>

          <div fxLayout="row" fxFlex="grow">
            <div style="max-height:650px; overflow-y:auto;">

              <div fxLayout="row wrap" style="margin-top:5px;" fxLayoutGap="20px">

                <div fxFlex="48" *ngFor="let item of automations; let i = index" class="questionBox1"
                     fxLayoutAlign="start center center">
                  <div fxFlexAlign="center"
                       style="word-break: break-word; overflow-wrap: break-word; width:100%; padding:5px;">
                    <div fxLayout="column" fxFlex="80">
                      <div fxLayout="row">
                      {{ item.description }}
                      </div>
                      <div fxLayout="row" *ngIf="item.selected">
                        <mat-form-field class="demo-chip-list" style="width: 100%;">
                          <mat-chip-list *ngIf="i === 0" #chipList>
                            <mat-chip
                                    style="background-color: var(--primary); color: white;"
                                    *ngFor="let email of emails"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="removeEmail(email)">
                              {{email}}
                              <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input
                                    placeholder="Νέο email"
                                    #emailInput
                                    [formControl]="emailsCtrl"
                                    [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList"
                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="addOnBlur"
                                    (matChipInputTokenEnd)="addEmail($event)"
                            />
                          </mat-chip-list>
                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                            <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                              {{ email.email }}
                            </mat-option>
                          </mat-autocomplete>

                          <mat-chip-list *ngIf="i === 1" #chipList1>
                            <mat-chip
                                    style="background-color: var(--primary); color: white;"
                                    *ngFor="let email of emails1"
                                    [selectable]="selectable"
                                    [removable]="removable"
                                    (removed)="removeEmail1(email)">
                              {{email}}
                              <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel</mat-icon>
                            </mat-chip>
                            <input
                                   placeholder="Νέο email"
                                   #emailInput1
                                   [formControl]="emailsCtrl1"
                                   [matAutocomplete]="auto1"
                                   [matChipInputFor]="chipList1"
                                   [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                   [matChipInputAddOnBlur]="addOnBlur"
                                   (matChipInputTokenEnd)="addEmail1($event)"
                            />
                          </mat-chip-list>


                          <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selected1($event)">
                            <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                              {{ email.email }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="20" fxLayoutAlign="end center center">
                      <mat-slide-toggle [checked]="item.selected" (change)="automationSelection(item.id)"></mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div fxFlex="grow" class="tabButtonSection">
          <div fxFlex="grow">
            <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
          </div>

          <div>
            <button mat-raised-button color="primary" matStepperNext (click)="next()">Επόμενο</button>
          </div>
        </div>
      </mat-step>


      <mat-step *ngIf="isAffirmation" label="Προεπισκόπηση και Δημιουργία">
        <div fxLayout="column">
          <!--                Text-->
          <div fxLayout="column" [innerHTML]="transform(htmlContent)" style="min-height:100px; padding: 10px;"></div>
          <table style="margin-top: 20px;">
            <tr>
              <th colspan="2">
                {{formTitle}}
              </th>
            </tr>
            <tr>
              <td>Ονοματεπώνυμο χρήστη:</td>
              <td>
                <mat-form-field appearance="outline" style="width:100%;">
                  <label>
                    <input matInput placeholder="Ονοματεπώνυμο χρήστη">
                  </label>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>Ονοματεπώνυμο:</td>
              <td>
                <mat-form-field appearance="outline" style="width:100%;">
                  <label>
                    <mat-select placeholder="Ονοματεπώνυμο"></mat-select>
                  </label>
                </mat-form-field>
              </td>
            </tr>
            <tr *ngIf="selectedActivity && selectedActivity.assignedLevels.length > 0">
              <td>Επίπεδο:</td>
              <td>
                <mat-form-field appearance="outline" style="width:100%;">
                  <mat-select>
                    <mat-option
                      *ngFor="let level of selectedActivity.assignedLevels">{{level.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </tr>
          </table>

          <div fxLayoutAlign="flex-end" fxFlex="grow" class="tabButtonSection">
            <div fxFlex="grow">
              <button mat-raised-button color="primary" matStepperPrevious>Προηγούμενο</button>
            </div>
            <div>
<!--              <button mat-raised-button color="primary" matStepperNext (click)="submitAffirmation()">-->
<!--                Δημιουργία-->
<!--              </button>-->
              <button *ngIf="!editMode" mat-raised-button class="stepperButton" matStepperNext (click)="submitForm()" [class.spinner]="requestLoading" [disabled]="requestLoading">
                Δημιουργία
              </button>
              <button *ngIf="editMode" class="stepperButton" mat-raised-button [class.spinner]="requestLoading" [disabled]="requestLoading"
                      (click)="submitForm()"
                      style="width:250px;">Ενημέρωση
              </button>
            </div>
          </div>
        </div>
      </mat-step>
      <!--      -->

    </mat-horizontal-stepper>
  </div>
</div>
